import { BrowserRouter, Routes, Route } from "react-router-dom";
import RaphaelaPortfolio from './RaphaelaPortfolio';
import Questionario from './pages/Questionario';
import AdminPanel from './pages/AdminPanel';

function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RaphaelaPortfolio />} />
        <Route path="/questionario" element={<Questionario />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRouter;
